module.exports = __webpack_public_path__ + "img/section5-1-desktop.413cefc9.png";